import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import { COLORS } from '../theme/theme-options';

const FAILURE_COLOR = COLORS.error?.[400] ?? COLORS.primary[400];

const strokeCircle = keyframes`
  0% {
    stroke-dashoffset: 166;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const strokeCross = keyframes`
  0% {
    stroke-dashoffset: 40;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const scale = keyframes`
  0%, 100% {
    transform: none;
  }

  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
`;

const fill = keyframes`
  0% {
    box-shadow: inset 0px 0px 0px 0px ${FAILURE_COLOR};
  }
  100% {
    box-shadow: inset 0px 0px 0px 30px ${FAILURE_COLOR};
  }
`;

const FailureIcon = styled('svg')({
  width: 100,
  height: 100,
  borderRadius: '50%',
  display: 'block',
  strokeWidth: 2,
  stroke: FAILURE_COLOR,
  strokeMiterlimit: 10,
  boxShadow: `inset 0px 0px 0px 0px ${FAILURE_COLOR}`,
  animation: `${fill} 0.4s ease-in-out 0.4s forwards, ${scale} 0.3s ease-in-out 0.9s both`,
  position: 'relative',
  top: 5,
  right: 5,
  margin: '0 auto',
});

const FailureCircle = styled('circle')({
  strokeDasharray: 166,
  strokeDashoffset: 166,
  strokeWidth: 2,
  strokeMiterlimit: 10,
  stroke: FAILURE_COLOR,
  fill: COLORS.grey[800],
  animation: `${strokeCircle} 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards`,
});

const CrossPath = styled('path')({
  transformOrigin: '50% 50%',
  strokeDasharray: 40,
  strokeDashoffset: 40,
  stroke: FAILURE_COLOR,
  strokeWidth: 2,
  strokeLinecap: 'round',
  fill: 'none',
  animation: `${strokeCross} 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards`,
});

export const FailureCheckmark: React.FC = () => {
  return (
    <FailureIcon viewBox="0 0 52 52">
      <FailureCircle cx={26} cy={26} r={25} />
      <CrossPath d="M18 18 L34 34" />
      <CrossPath d="M34 18 L18 34" />
    </FailureIcon>
  );
};
